//@ts-check
import axios from 'axios';
import { getfetchopts } from "../../utils/fetchutils.js";
import appAction from "./appAction";
import { AccountConstants, AppConstants, roleTypeConstants, globalConstants } from "../../constants/constants";
import { tableHoc } from "utils/table";
import { filterMenu } from "utils";
import cloneDeep from "clone-deep";


export function signIn(param) {
  return async (dispatch) => {
    let res;
    try {
      const config = getfetchopts({
        method: 'POST',
        url: '/api/auth/login',
        data: {
          username: param.username,
          password: param.password,
          session_id: param.session_id,
          code: param.code
        }
      });
      const result = await axios.request(config);
      console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
      res = result.data;
    } catch (e) {
      console.error("Error: ", e);
      if (e.response && e.response.status == 401) {
        dispatch(logout()); //reroutes to login page
        throw new Error(e.response?.data?.message || 'Login failed. Please check your username or password.');
      }
    }
    if (!res.ok) {
      throw new Error('Login failed');
    }

    let curSignature;
    try {
      const config = getfetchopts({
        method: 'GET',
        url: '/api/core/fs/signature'
      });
      const result = await axios.request(config);
      console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
      curSignature = result.data;
    } catch (e) {
      console.error('Error:', e);
      const status = e.response?.status;
      const authErrorCodes = [401];
      if (authErrorCodes.includes(status)) {
        logout();
      }
      throw new Error('Login failed');;
    }
    const { urlprefix, signature } = curSignature;
    sessionStorage.setItem(AppConstants.FS_URL_PREFIX, encodeURIComponent(urlprefix));
    sessionStorage.setItem(AppConstants.FS_URL_SIGNATURE, encodeURIComponent(signature));
    const { authorizationCode } = res; //what the hell is this? This needs to be checked and probably removed.
    if (authorizationCode) return { authorizationCode };

    // clear pre cookie
    sessionStorage.removeItem(AppConstants.CURRENT_ORGANIZATION);
    sessionStorage.removeItem(AppConstants.CURRENT_LOCATION);
    sessionStorage.removeItem(AppConstants.CURRENT_ACCOUNT);

    dispatch({
      type: AppConstants.CURRENT_ORGANIZATION,
    });
    dispatch({
      type: AppConstants.CURRENT_LOCATION,
    });
    dispatch({
      type: AppConstants.CURRENT_ACCOUNT,
    });

    dispatch({
      type: AppConstants.INIT_DATA,
    });

    let current;
    try {
      const config = getfetchopts({
        method: 'GET',
        url: '/api/accounts/current'
      });
      const result = await axios.request(config);
      console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
      current = result.data;
    } catch (e) {
      console.error('Error:', e);
      const status = e.response?.status;
      const authErrorCodes = [401];
      if (authErrorCodes.includes(status)) {
        logout();
      }
      throw new Error('Login failed');
    }

    sessionStorage.setItem(AppConstants.CURRENT_ACCOUNT, encodeURIComponent(current.account_id));
    dispatch({
      type: AppConstants.CURRENT_ACCOUNT,
      payload: current.account_id,
    });
    dispatch({
      type: AccountConstants.SIGN_IN,
      data: current,
    });

    if (current && current.organization_ids.length === 1 && current.role_type !== roleTypeConstants.SPECTRALINK_USER) {
      await dispatch(appAction.setCurrentOrganization(current.organization_ids[0]));
    }
    //dispatch(await appAction.loadCustomers());
    //dispatch(await appAction.loadSites());
    // dispatch(commomAction.getOrganizations());
    // dispatch(commomAction.getLocationOptions());
    await dispatch(appAction.initGlobalData());
    // await dispatch(commomAction.getSettingsList());
    // await Promise.all([
    //     dispatch(commomAction.getSettingsList()),
    //     dispatch(appAction.getSpectralinkAdmin()),
    // ]);

    return {
      lastLogin: res.lastLogin,
      token: res.token,
      isTemporaryPassword: current.is_temporary_password,
    };
  };
}
async function doLogout() {
  try {
    const config = getfetchopts({
      method: 'GET',
      url: '/api/auth/logout'
    });
    const result = await axios.request(config);
    console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
  } catch (e) {
    console.error('Error:', e);
    throw e;
  }
}
export function logout() {
  doLogout();

  const current_language = sessionStorage.getItem(AppConstants.CURRENT_LANGUAGE)
    ? decodeURIComponent(sessionStorage.getItem(AppConstants.CURRENT_LANGUAGE))
    : null;

  sessionStorage.removeItem(AppConstants.CURRENT_CUSTOMER);
  sessionStorage.removeItem(AppConstants.CURRENT_ORGANIZATION);
  sessionStorage.removeItem(AppConstants.CURRENT_LOCATION);
  sessionStorage.removeItem(AppConstants.CURRENT_ACCOUNT);
  sessionStorage.removeItem(AppConstants.FS_URL_PREFIX);
  sessionStorage.removeItem(AppConstants.FS_URL_SIGNATURE);
  return (dispatch) => {
    dispatch({
      type: AppConstants.CURRENT_CUSTOMER,
    });
    dispatch({
      type: AppConstants.CURRENT_ORGANIZATION,
    });
    dispatch({
      type: AppConstants.CURRENT_ACCOUNT,
    });
    dispatch({
      type: "USER_LOGOUT",
    });
    dispatch({
      type: AccountConstants.LOGOUT,
    });
    dispatch({
      type: AppConstants.INIT_APP,
    });
    dispatch({
      type: AppConstants.SET_APP_LANGUAGE,
      payload: current_language,
    });
    document.title = AppConstants.TITLE;
  };
}

export function refresh(type) {
  return async (dispatch) => {
    try {
      let current;
      try {
        const config = getfetchopts({
          method: 'GET',
          url: '/api/accounts/current'
        });
        const result = await axios.request(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
        current = result.data;
      } catch (e) {
        console.error('Error:', e);
        const status = e.response?.status;
        const authErrorCodes = [401];
        if (authErrorCodes.includes(status)) {
          logout();
        }
        throw e;
      }
      if (!type) {
        if (
          current &&
          current.organization_ids.length === 1 &&
          current.role_type !== roleTypeConstants.SPECTRALINK_USER
        ) {
          await dispatch(appAction.setCurrentOrganization(current.organization_ids[0]));
        }
      }
      dispatch({
        type: AccountConstants.SIGN_IN,
        data: current,
      });

      let menus = cloneDeep(globalConstants.MENUS);
      menus = filterMenu(menus, current.permissions, current.role_type);
      dispatch(appAction.setMenus(menus));
      // dispatch(commomAction.getOrganizations());
      // dispatch(commomAction.getRolegetOptions());
      // dispatch(commomAction.getLocations());
      // dispatch(commomAction.getLocationOptions());

      // await Promise.all([
      //     dispatch(commomAction.getSettingsList()),
      //     dispatch(appAction.getSpectralinkAdmin()),
      // ]);
      // await dispatch(commomAction.getSettingsList());
      await dispatch(appAction.initGlobalData());
    } catch (e) {
      console.log(e);
      logout();
    }
  };
}
export function refreshAccount() {
  return async (dispatch) => {
    try {
      let current;
      try {
        const config = getfetchopts({
          method: 'GET',
          url: '/api/accounts/current'
        });
        const result = await axios.request(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
        current = result.data;
      } catch (e) {
        console.error('Error:', e);
        const status = e.response?.status;
        const authErrorCodes = [401];
        if (authErrorCodes.includes(status)) {
          logout();
        }
        throw e;
      }

      dispatch({
        type: AccountConstants.SIGN_IN,
        data: current,
      });

      let menus = cloneDeep(globalConstants.MENUS);
      menus = filterMenu(menus, current.permissions, current.role_type);

      dispatch(appAction.setMenus(menus));
    } catch (e) {
      console.log(e);
      logout();
    }
  };
}
export function getCurrentAccountInfo() {
  return async (dispatch) => {
    try {
      let current;
      try {
        const config = getfetchopts({
          method: 'GET',
          url: '/api/accounts/current'
        });
        //@ts-ignore
        const result = await axios.request(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
        current = result.data;
      } catch (e) {
        console.error('Error:', e);
        const status = e.response?.status;
        const authErrorCodes = [401];
        if (authErrorCodes.includes(status)) {
          logout();
        }
        throw e;
      }
      dispatch({
        type: AccountConstants.SIGN_IN,
        data: current,
      });
    } catch (e) {
      await dispatch(await logout());
    }
  };
}

export const getTableData = tableHoc(async (filter, sort, pagination) => {
  return {
    res: await (async () => {
      try {
        const sortingParams = sort?.field && sort?.order ? {
          sort_order: sort.order === 'descend' ? 'DESC' : 'ASC',
          sort_field: sort.field
        } : {};
        const params = {
          ...filter,
          ...sortingParams
        };
        const queryString = new URLSearchParams(params).toString();
        const config = getfetchopts({
          method: 'GET',
          url: '/api/accounts/?' + queryString
        });
        const result = await axios.request(config);
        console.info(`DEBUG RESPONSE: ${config.method} ${config.url}`, result);
        return result.data;
      } catch (e) {
        console.error('Error:', e);
        const status = e.response?.status;
        const authErrorCodes = [401];
        if (authErrorCodes.includes(status)) {
          logout();
        }
        throw e;
      }
    })(),
    actionType: AccountConstants.GET_ACCOUNTS_TABLE_DATA,
  };
});
